const Strings = Object.freeze({
  // ---------------------------- Traffic Errors ----------------------------
  INPUT_ERRORS: "input errors: ",
  OUTPUT_ERRORS: "output errors: ",

  CABLE_DELAY: "Cable delay",
  LINE_DELAY: "Line delay",
  DELAY_POPUP_1: "Indicates two different propagation delays (one or the other, depending on the device response).",
  DELAY_POPUP_2: "Variations in these values indicate physical problems in the infrastructure (cabling and connectors) and, in the case of “Line delay”, it may indicate a problem in the network interfaces (transmitters and receivers).",
  DELAY_POPUP_3: "The maximum indicative value for the “Cable delay” is 548 ns.",
  DELAY_POPUP_4: "The different delays indicated are:",
  DELAY_POPUP_5: "Propagation delay only on the wired part;",
  DELAY_POPUP_6: "Includes Ethernet cable, transmitter and receiver delays.",

  IN_ERRORS_POPUP: "Indicates the sum of all packets received with some kind of error. When there are errors of this type, it is suggested:",
  OUT_ERRORS_POPUP: "Indicates the sum of all packets with some kind of error that prevented the correct transmission. When there are errors of this type, it is suggested:",
  SOLVE_ERRORS_POPUP: "Correction suggestions are indicated in the action list. To gain access, simply click the \"Export action list\" button on the TS Expert screen.",

  TURN_ON: "turn on",
  TURN_OFF: "turn off",
  TURNED_ON_1: "ON",
  MEASUREMENT_INTERVAL: "Measurement period",

  DUPLEX_MODE_POPUP: "Indicates the interface's Duplex mode (Full or Half Duplex) and the baud rate.",

  IN_PACKETS: "In packets",
  OUT_PACKETS: "Out packets",

  ARE_YOU_SURE_YOU_WANT: "Are you sure you want to ",
  THE_PORTS_FILTER: " the ports filter?",

  // ---------------------------- Configuration page related ----------------------------
  LOGIN_CREDENTIALS_FAILURE: "An error occurred while logging in: The username or password are incorrect.",
  LOGIN_GENERAL_FALIURE: "An error occurred while logging in",
  GPG_ALERT_MESSAGE: "It is only possible to send files with a .gpg extension",
  XML_ALERT_MESSAGE: "It is only possible to send files with a .xml extension",
  SEND_FILE_SUCCESS: "The file was sent successfully.",
  SEND_FILES_SUCCESS: "The files were sent successfully.",
  SEND_FILE_SUCCESS_WARNING: "Don't forget to check if your computer's network card is on the same IP subnet as: ",
  SEND_FILE_FAILURE: "An error occurred while sending the file.",
  SEND_FILES_FAILURE: "An error occurred while sending the files.",
  SEND_FILE_WAITING: "Sending the file.",
  SEND_FILES_WAITING: "Sending the files,",
  SEND_FILE_WRONG_FILENAME: "Invalid name. The update file should be named: updatePN.tar.gz.gpg",
  SEND_FILE_CORRUPTED_FILE: "The update file was corrupted while the upload was in proccess.",
  THE_FOLLOWING_FILES_COULD_NOT_BE_SENT: "An error occurred while sending the following GSDML files: ",
  THE_FOLLOWING_FILES_COULD_NOT_BE_REMOVED: "An error occurred while removing the following GSDML files: ",
  SEND_CONFIG_SUCCESS: "The settings have been sent successfully.",
  SEND_CONFIG_FAILURE: "An error occurred while sending the settings.",
  SEND_NTP_CONFIG_WAITING: "Sending NTP server settings.",
  SEND_NTP_CONFIG_DONE: "NTP Server Settings have been sent.",

  SEND_CONFIG_WAITING: "Sending settings.",
  SEND_CONFIG_WAITING_2: "Finishing sending the settings.",
  SEND_CONFIG_DONE: "Sent settings.",
  SEND_WLAN_CONFIG_WAITING: "Sending settings, please wait. This might take about a minute.",
  UPDATE_WLAN_CONFIG_ERROR: "Unable to connect to the WLAN network. If the problem persists, try restarting the monitor or the WLAN router.",
  UPDATE_OFFICE_INTERFACE_CONFIG_ERROR: "An error ocurred while configuring the office interface. If the problem persists, try restarting the monitor or router.",

  LOADING_WAITING: "Loading info, please wait.",

  START_MESSAGE_SUCCESS: "The monitor will start in 15 seconds.",
  START_MESSAGE_FAILURE: "There was an error while starting the monitor.",
  STOP_MESSAGE_SUCCESS: "The monitor will stop in 15 seconds.",
  STOP_MESSAGE_FAILURE: "An error occurred while stopping the monitor.",
  WAITING: "Wait a moment",
  CLEAN_LOG_SUCCESS: "The log has been cleared successfully.",
  CLEAN_LOG_FAILURE: "An error occurred while clearing the log.",
  RESET_TRAFFIC_SUCCESS: "The values will be zeroed on the next scan.",
  RESET_TRAFFIC_FAILURE: "An error occurred while resetting the error increments.",
  RESET_DEVICES_SUCCESS: "Device data has been cleared successfully.",
  RESET_DEVICES_FAILURE: "An error occurred while clearing device data.",
  CHANGE_USERNAME_SUCCESS: "The username has been changed successfully. Please login again.",
  CHANGE_USERNAME_FAILURE: "An error occurred while changing the username:",
  USERNAME_TOO_SHORT: "The username must contain at least one character.",
  PASSWORD_MISSMATCH: "The passwords entered do not match",
  CHANGE_PASSWORD_SUCCESS: "The password has been changed successfully. Please login again.",
  CHANGE_PASSWORD_FAILURE: "An error occurred while changing the password: ",

  VERIFY_THE_FOLLOWING_INFO: "Please check the following information:",
  INVALID_IP: "\n- The IP entered is invalid",
  INVALID_SUBMASK: "\n- The mask entered is invalid",
  INVALID_GATEWAY: "\n- The gateway entered is invalid",
  INVALID_DNS: "\n- The DNS entered is invalid",
  LOOPBACK_IP: "\n- Loopback IP (127.0.0.1) cannot be used as the monitor IP",
  LOOPBACK_IP_NTP: "\n- Loopback IP (127.0.0.1) cannot be used as the NTP server IP",
  TAG_TOO_LONG: "\n- Tag length cannot exceed 30 characters",
  EMPTY_WIFI_PWD: "\n- Wifi password cannot be empty",
  SELECT_TIMEZONE: "\n- It is necessary to select a Timezone to configure the NTP server",
  SAME_SUBNET_IP_1: "\n- The IP address of the office interface cannot be in the same subnet as the PROFINET interface.",
  SAME_SUBNET_IP_2: "\n- The IP address of the PROFINET interface cannot be in the same subnet as the office interface.",
  SUBNET_OVERLAP_OFFICE: "\n- The TS Monitor PROFINET detected that there is an overlap of addresses between the PROFINET interface subnet and the office interface subnet. For this reason, it is not possible to configure the office interface with the chosen IP address and mask.",
  SUBNET_OVERLAP_PROFINET: "\n- The TS Monitor PROFINET detected that there is an overlap of addresses between the PROFINET interface subnet and the office interface subnet. For this reason, it is not possible to configure the PROFINET interface with the chosen IP address and mask.",
  SUBNET_OVERLAP_WLAN: "\n- The TS Monitor PROFINET detected that there is an overlap of addresses between the PROFINET interface subnet and the WLAN subnet. For this reason, it is not possible to configure the WLAN with the chosen IP address and mask.",
  SUBNET_OVERLAP_PROFINET_WLAN: "\n- The TS Monitor PROFINET detected that there is an overlap of addresses between the PROFINET interface subnet and the WLAN subnet. For this reason, it is not possible to configure the office interface with the chosen IP address and mask.",
  ZERO_IP_MSG: "\n- IP 0.0.0.0 cannot be used as the monitor's IP",
  ZERO_IP_MASK_MSG: "\n- IP 0.0.0.0 cannot be used as a network mask",
  BROADCAST_IP_MSG: "\n- The network broadcast IP cannot be used as the monitor's IP",
  NETWORK_IP_MSG: "\n- The network IP cannot be used as the monitor IP",
  BROADCAST_GATEWAY_MSG: "\n- The network's broadcast IP cannot be used as the gateway IP",
  NETWORK_GATEWAY_MSG: "\n- The network's IP cannot be used as the gateway IP",

  MONITORING_ON: "Turned on",
  MONITORING_OFF: "Turned off",

  GENERATING_REPORT_WAITING: "Generating report, please wait",

  ALTER_USERNAME: "CHANGE USER",
  ALTER_PASSWORD: "CHANGE PASSWORD",

  SELECT_FILE: "Please select a file to upload",
  SELECT_AT_LEAST_ONE_FILE: "Please select at least one file to upload",
  SELECT_AT_LEAST_ONE_FILE_TO_DELETE: "Please select at least one file to remove",

  DO_NOT_CLOSE_THIS_TAB: "Leave this tab open to keep track of the update.",
  UPDATING_MONITOR_FILES: "Updating files on the monitor. Please wait.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY: "All files were updated, preparing to restart the monitor.",
  RESTARTING_MONITOR_WAIT: "Restarting the monitor, wait a few minutes.",
  UPDATE_SUCCESS: "The update was applied successfully!",
  UPDATE_ERROR_STRING: "The following error occurred while updating the monitor: ",

  SWEEP_POPUP_MSG: " Allows custom scan configuration for up to 5 subnets.",
  MONITORING_QUESTION_ICON_INFO: "Enables and disables the sending and capturing of messages actively. When turned off, the monitor does not send messages, and does not acquire data.",
  DEVICE_SEARCH_QUESTION_ICON_INFO: "Select continuous (constant) or single search, to decrease message sending. In single search mode, new devices that appear on the network will not be found.",
  GSDML_QUESTION_ICON_INFO: "Loading the GSDml files in TS Monitor considerably expands the diagnostic capability of the assets, allowing the interpretation of manufacturer-specific information that can only be shown if the monitor has these files loaded.",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Modify at least one of the fields to update the interface settings.",
  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Modify at least one of the fields to update the WLAN settings.",

  TAG_WAS_CHANGED_SUCCESSFULLY: "The monitor tag has been changed successfully.",
  TAG_CHANGE_FAILURE: "An error occurred while changing the monitor tag.",

  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nRemember to update the address in the browser to: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "Interface settings were updated successfully!",
  UPDATE_WLAN_CONFIG_SUCCESS: "WLAN settings were updated successfully!",
  UPDATE_OFFICE_INTERFACE_CONFIG_SUCCESS: "The office interface settings have been updated successfully!",

  CONTINUOUS: "Continuous",
  UNIQUE: "Single",

  ALTER_MONITOR_CONFIG: "Are you sure you want to change monitor settings?",
  RESTART_SYSTEM: " Restart System",
  CONFIRM_RESTART_SYSTEM: "Are you sure you want to restart the system?",
  RESTART_SYSTEM_FAILURE: "An error occurred while trying to restart the system.",
  RESTART_SYSTEM_SUCCESS: "The reset request was sent successfully. Wait about 3 minutes for the system to restart completely.",

  WI_FI: "Wi-fi",
  MANAGE: "Manage",

  TAG_CONFIG: "Network tag",

  ETHERNET: "Ethernet",
  WLAN: "WLAN",

  NTP_SERVER: "NTP server",

  TURN_NTP_SERVER_ON: "Turn NTP server on",
  TURN_NTP_SERVER_ON_QUESTION: "Are you sure you want to turn on the NTP server? To do this, the monitor must be restarted.",

  NTP_INFO_TURNED_ON_SUCCESS: "The NTP server was turned on successfully.",
  NTP_INFO_TURNED_ON_FAILURE: "An error occurred while turning the NTP server on.",
  TURN_ON_DATE: "\nServer time has been updated to: ",

  MONITOR_WILL_BE_RESTARTED: "\nThe monitor will restart now,",
  MONITOR_RESTART_SUCCESS: "The monitor has restarted successfully.",
  MONITOR_RESTART_FAILURE: "An error occurred while restarting the monitor.",

  NTP_INFO_TURNED_OFF_SUCCESS: "The NTP server was turned off successfully.",
  NTP_INFO_TURNED_OFF_FAILURE: "An error occurred while turning off the NTP server.",
  TURN_OFF_DATE: "\nShutdown time: ",
  NTP_INFO_FAILURE: "Failed to sync with the NTP server. If the error persists, contact the administrator of the NTP server.",

  PROCESSING_NTP_INIT: "Starting processing of NTP server information.",
  PROCESSING_NTP_INFO: "Processing NTP server information.",
  PROCESSED_NTP_INFO: "Processed NTP server information.",
  PROCESSING_NTP_ERROR: "An error occurred while sending the information to the NTP server. Check that the server's IP address is correct. If so, also check if the NTP service is turned on and try again.",

  ETHERNET_CONFIG_POPUP: "Leads to the configuration page of the Ethernet interface connected to the industrial network, which is used by TS Monitor for data capture.",
  WLAN_CONFIG_POPUP: "Leads to the wireless interface configuration page. When the adapter is available, it is used for supervision and Web access to TS Monitor data. This network is isolated from the Ethernet/Industrial network.",
  OFFICE_CONFIG_POPUP: "Configuration field for the Ethernet interface used for supervision and Web access to TS Monitor data. This network is isolated from the Ethernet / Industrial network.",
  BLACKLIST_CONFIG_POPUP: "Allows the exclusion of some data collection services of the TS Monitor.",
  TS_EXPERT_CONFIG_POPUP: "Allows enabling / disabling of the non-conformities to be reported by the tool.",

  ALTER: "Change",
  USER: "User",
  NEW_PWD: "New password",
  REPEAT_PWD: "Repeat password",
  REASON_DP: "Reason: ",
  TEST_NETWORK: "Test network",
  EDIT: "Edit",
  SWEEP: "Scan",
  DEVICE_SEARCH: "Device search",
  SOFTWARE_UPDATE: "Software update",
  CURRENT_VERSION: "Current version: ",
  UPDATE: "Update",
  GSDML_FILES: "GSDML files",
  SEND: "Send",
  CLEAR: "Clear",
  TRAFFIC_ERROR_INCREMENT: "Traffic error increment",
  REPORT: "Report",
  ALTER_LOGIN: "Change login",
  INTERFACE_CONFIG: "Interface settings",
  INTERFACE_PROFINET_CONFIG: "PROFINET interface settings",
  ENTER: "Login",

  SNMP_MODE: "SNMP Mode",
  SNMP_MODE_QUESTION_ICON_INFO_1: "When placing the TS Monitor PROFINET on the network, if you detect that some devices are not operating correctly, you can activate the slow SNMP mode.",
  SNMP_MODE_QUESTION_ICON_INFO_2: "Activating this mode will considerably decrease the rate at which SNMP queries are sent, which may solve the problem.",
  SNMP_MODE_FAST: "Fast",
  SNMP_MODE_SLOW: "Slow",
  SNMP_MODE_WAS_CHANGED_SUCCESSFULLY: "The SNMP mode was changed successfully.",
  SNMP_MODE_CHANGE_FAILURE: "An error occurred while changing the SNMP mode.",

  PROFINET_INTERFACE: "PROFINET Interface",
  OFFICE_INTERFACE: "OFFICE Interface",

  // ---------------------------- Sweep Page ----------------------------
  PERSONALIZED_SWEEP: "Personalized scan",

  SWEEP_ON: "Turned on",
  SWEEP_OFF: "Turned off",
  BANDS: "Range",

  FIRST_BAND: "1st Range",
  SECOND_BAND: "2nd Range",
  THIRD_BAND: "3rd Range",
  FOURTH_BAND: "4th Range",
  FIFTH_BAND: "5th Range",

  BEGINNING: "Beginning",
  END: "End",

  ALERT_MESSAGE_PLACEHOLDER: "The fields of the following ranges have problems: ",

  FIRST_SUBNETWORK_ADDRESS_NOT_VALID: "\n - 1st range address is not valid",
  FIRST_SUBNETWORK_START_LESS_THAN_FINISH: "\n -The start address of the 1st range is greater than or equal to the end",
  FIRST_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - The 1st range has unfilled fields",

  SECOND_SUBNETWORK_ADDRESS_NOT_VALID: "\n - 2nd range address is not valid",
  SECOND_SUBNETWORK_START_LESS_THAN_FINISH: "\n - The start address of the 2nd range is greater than or equal to the end",
  SECOND_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - The 2nd range has unfilled fields",

  THIRD_SUBNETWORK_ADDRESS_NOT_VALID: "\n - 3rd range address is not valid",
  THIRD_SUBNETWORK_START_LESS_THAN_FINISH: "\n - The start address of the 3rd range is greater than or equal to the end",
  THIRD_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - The 3rd range has unfilled fields",

  FOURTH_SUBNETWORK_ADDRESS_NOT_VALID: "\n - 4th range address is not valid",
  FOURTH_SUBNETWORK_START_LESS_THAN_FINISH: "\n - The start address of the 4th range is greater than or equal to the end",
  FOURTH_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - The 4th range has unfilled fields",

  FIFTH_SUBNETWORK_ADDRESS_NOT_VALID: "\n - 5th range address is not valid",
  FIFTH_SUBNETWORK_START_LESS_THAN_FINISH: "\n - The start address of the 5th range is greater than or equal to the end",
  FIFTH_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - The 5th range has unfilled fields",

  SWEEP_DATA_SENT_SUCCESSFULLY: "The scan settings have been saved successfully.",
  SWEEP_DATA_SENT_ERROR: "An error occurred while saving the scan settings.",
  SPECIFY_AT_LEAST_ONE_SUBNETWORK: "You must specify at least one subnet to save the custom scan.",

  UNABLE_TO_SAVE_CUSTOM_SWEEP: "It is not possible to save the personalized scan because:",
  _THE: "- The range ",
  BAND_HAS_IPS_NOT_IN_SUBNETWORK: " contains IPs that are not on the monitor's subnet",
  SENDING_DATA: "Sending data",

  // ---------------------------- PDF Report ----------------------------
  REPORT_EXPORT_NAME_PDF: "TS Monitor PROFINET Report.pdf",
  FINISHING: "Finishing...",
  SAVE_REPORT: "Save report",

  PROJECT_NAME_1: "Project name",
  LOCATION_1: "Location",
  COMPANY_NAME_1: "Company name",
  RESPONSIBLE_NAME: "Name of person in charge",
  ADDRESS: "Address",
  CITY: "City",
  TEL: "Telephone",
  CLIENT_LOGO: "Client logo",
  EMAIL: "E-mail",
  EXECUTING_COMPANY_LOGO: "Executing company logo",

  GENERAL_INFO_TITLE: "1. Overview",
  LIVE_LIST_TITLE: "2. Live List",
  TOPOLOGY_TITLE: "3. Topology",
  TRAFFIC_INPUT_TITLE: "4. In traffic errors",
  TRAFFIC_OUTPUT_TITLE: "5. Out traffic errors",
  LOG_PAGE_TITLE: "6. Event log",

  ACTIVE_TYPE: "ACTIVE",
  NOT_ACTIVE_TYPE: "NOT ACTIVE",

  CONFORM_STRING: "Conform",
  CONFORM_W_RESTRICTION_STRING: "Conform with restrictions",
  NON_CONFORM_STRING: "Not conform",

  GENERATING_REPORT_SUCCESS: "The report was generated successfully. To save it, click on save report below.",

  CONFORMITY: "Conformity",
  DROPDOWN_PLACEHOLDER: "Choose an option",
  GENERATE_REPORT: "Generate report",
  CLIENT_INFO: "Client information",
  EXECUTING_COMPANY_INFO: "Executing company information",
  ANNOTATIONS: "Notes",
  CONCLUSION: "Conclusion",

  HEADER_TEXT: "Data report - TS Monitor PROFINET",
  REPORT_EXPORT_NAME: "TS Monitor PROFINET report",

  GENERAL_REPORT: "General report – TS Monitor PROFINET",
  DATA_REPORT: "Data report – TS Monitor PROFINET",

  PROJECT_NAME: "- Project name:",
  NETWORK_NAME: "- Network name:",
  LOCATION: "- Location:",
  COMPANY_NAME: "- Company name:",
  ACCOUNTABLE_NAME: "- Name of person in charge:",
  COMPANY_ADDRESS: "- Address:",
  COMPANY_CITY: "- City:",
  COMPANY_TEL: "- Telephone:",

  EXECUTING_COMPANY_NAME: "- Company name:",
  EXECUTING_ACCOUNTABLE_NAME: "- Name of person in charge:",
  EXECUTING_TEL: "- Telephone:",
  EXECUTING_EMAIL: "- Email:",

  MONITORING_INFO: "Monitoring information",
  ETHERNET_INFO: "ETHERNET information",
  WLAN_INFO: "WLAN information",
  ETHERNET_OFFICE_INFO: "ETHERNET Office information",

  NETWORK_TAG_DP: "- Network tag: ",
  NETWORK_NAME_DP: "- Network name: ",
  MONITOR_IP_DP: "- Monitor IP: ",
  MONITOR_SUBMASK_DP: "- Monitor mask: ",
  MONITOR_VERSION_DP: "- Monitor version: ",
  MONITOR_TIME_ON_DP: "- Uptime: ",
  MEASUREMENT_INTERVAL_DP: "- Measurement period: ",
  REPORT_GENERATION: "- Report generation: ",

  IP_DP: "- IP: ",
  MASK_DP: "- Mask: ",
  GATEWAY_DP: "- Gateway: ",
  DNS_DP: "- DNS: ",
  MODO_DP: "- Configuration mode: ",

  SUMMARY: "Summary",
  OVERVIEW: "Overview",
  LIVE_LIST: "Live List",
  INVENTORY: "Inventory",
  TOPOLOGY: "Topology",
  GRAPHIC_TOPOLOGY: "Graphic Topology",
  IN_TRAFFIC_ERRORS: "In traffic errors",
  OUT_TRAFFIC_ERRORS: "Out traffic errors",
  LOG: "Log",
  CONFIG: "Settings",
  DISCLAIMER: "Legal notice",

  M_MONITORING_OVERVIEW_PAGE_TITLE: "1. - Overview",
  M_MONITORING_LIVE_LIST_PAGE_TITLE: "2. - Live List",
  M_MONITORING_INVENTORY_PAGE_TITLE: "3. - Inventory",
  M_MONITORING_TOPOLOGY_PAGE_TITLE: "4. - Topology",
  M_MONITORING_IN_TRAFFIC_ERRORS_PAGE_TITLE: "5. - In traffic errors",
  M_MONITORING_OUT_TRAFFIC_ERRORS_PAGE_TITLE: "6. - Out traffic errors",
  M_MONITORING_LOG_PAGE_TITLE: "7. - Event log",

  TS_MONITOR_VER_DP: "TS Monitor PROFINET - Version ",
  NETWORK_STATUS_DP: "Network status: ",
  DEVICE_DATA: "Device data",

  CONTROLLERS_DP: "IO Controllers: ",
  DEVICES_DP: "IO Devices: ",
  SUPERVISORS_DP: "Supervisors: ",
  SUPERVISORS: "Supervisors",
  OTHER_DEVICES_DP: "Not PROFINET: ",
  OTHER_DEVICES: "Not PROFINET",
  FAULTS_DP: "Faults: ",
  ALARMS_DP: "Alarms: ",
  IN_TRAFFIC_DP: "Incoming ethernet traffic: ",
  OUT_TRAFFIC_DP: "Outgoing ethernet traffic: ",
  NETWORK_AVAILABILITY_DP: "Network availability: ",

  NAME: "Name",
  MODEL: "Model",
  MAC: "MAC",
  MACS: "MACs",
  IP: "IP",
  IPS: "IPs",
  FUNCTION: "Role",
  STATUS: "Status",
  ON_TIME: "Uptime",
  EVENT_TYPE: "Event type",

  MONITORING_BLACKLIST_STRING: "Monitoring blacklist",
  MONITORING_BLACKLIST_STRING_1: "Monitoring",
  MONITORING_BLACKLIST_STRING_2: "blacklist",
  OFFLINE_STRING: "Offline",
  ONLINE_STRING: "Online",
  FAULT_STRING: "Fault",
  DUPLICATE_IP_STRING: "Duplicate IP",
  CONFIG_ERROR_STRING: "Configuration error",

  BLACKLIST_OK_STRING: "Blacklist - OK",
  BLACKLIST_ALARM_STRING: "Blacklist - Alarm",
  BLACKLIST_OFFLINE_STRING: "Blacklist - Offline",
  BLACKLIST_ONLINE_STRING: "Blacklist - Online",
  BLACKLIST_FAULT_STRING: "Blacklist - Fault",
  BLACKLIST_DUPLICATE_IP_STRING: "Blacklist - Duplicate IP",
  BLACKLIST_CONFIG_ERROR_STRING: "Blacklist - Configuration error",

  SNMP: "SNMP",
  PORT: "Port",
  NEIGHBOUR_NAME: "Neighbor name",
  NEIGHBOUR_PORT_1: "Port",
  NEIGHBOUR_PORT_2: "neighbor",
  NEIGHBOUR_IP: "Neighbor IP",

  LAST_200_EVENTS: "200 last events",
  DESCRIPTION: "Description",
  HORARY: "Time",

  END_OF_REPORT: "End of report",
  DISCLAIMER_TEXT: "The data and values presented in this report are merely auxiliary for the PROFINET specialist, in such a way that any correction indication must be made by the user. For this reason, it is recommended to be accompanied by a PROFINET certified engineer or technician responsible for the analysis to certify the information provided by the product. Therefore, Toledo & Souza disclaims any liability, loss or damage, direct or indirect, caused by the interpretations of the software, not offering any guarantee in relation to the integrity, quality or adequacy of the information provided, as they depend on the technical analysis of a trained professional, in the absence of this, the user will assume the risk that the content may be inaccurate, incomplete or may not meet their needs and requirements.",

  NO_INPUT_TRAFFIC_ERRORS: "The network has no errors in incoming traffic",
  NO_OUTPUT_TRAFFIC_ERRORS: "The network has no errors in outgoing traffic",

  DEVICE_HAS_JOINED_THE_NETWORK: "The device has joined the network",
  DETAILS: "Details:",

  PAGE: "Page",
  INPUT: "In",
  OUTPUT: "Out",
  ERRORS_IN: "Errors",
  PORT_STATUS: "Port status",
  REPORTING: " reporting:",
  TIP: "Tip:",
  THE_DEVICE: "The device",
  OF_IP: "of IP",
  JOINED_THE_NETWORK: "joined the network.",
  THE_PORT: "The port",
  IS_CONNECTED_WITH_PORT: "is connected to the port",
  FROM_DEVICE: "of the device",

  // ---------------------------- Alarms ----------------------------
  ACTIVE_DP: "Active:",
  NOT_ACTIVE_DP: "Not active:",
  ALARM: "Alarm",
  ALARMS: "Alarms",

  // ---------------------------- OTHERS ----------------------------
  BEFORE_MONITOR_INIT_STR: "Before last initialization",
  REMOVE_DEVICE_SUCCESS: "The device will be removed in up to 30 seconds.",
  REMOVE_DEVICE_FAILURE: "An error occurred while removing the device.: ",

  OK_STRING: "OK",
  WITH_DIAGNOSTIC_STRING: "With alarm",
  WITH_FAILURE_STRING: "With fault",
  UNKNOWN: "Unknown",
  NO_ANSWER: "No answer",
  NO_EVENT: "No event",
  LOG_WAITING: "Loading log data",
  GO_TO_LOG_OR_REMOVE_POSITIONING: "Go to log or delete device",
  ASK_DELETE_OR_LOG: "Do you want to go to the log page or delete the device from the list?",
  DELETE: "Delete",
  GO_TO_LOG: " Go to log",
  LIVE_LIST_INPUT_TEXT_PLACEHOLDER: "Filter by IP, MAC, name, or status",
  TOPOLOGY_INPUT_TEXT_PLACEHOLDER: "Filter by IP, name or model",
  TRAFFIC_INPUT_TEXT_PLACEHOLDER: "Filter by IP or name",
  LOG_INPUT_TEXT_PLACEHOLDER: "Filter by name, model or IP",
  GRAPHIC_TOPOLOGY_INPUT_PLACEHOLDER: "Search by IP, Tag or profiname",
  PING_INPUT_TEXT_PLACEHOLDER: "Filter by IP or MAC",
  FAULTS: "Faults",
  ACTUAL_MEDIUM: "Current / Average",
  AVAILABILITY: "Availability",
  STATISTICS: "Statistics",
  BILLIONS_OF: "Billions of",
  ONE_MILLION_OF: "Million of",
  ONE_BILLION_OF: "Billion of",
  MILLIONS_OF: "Millions of",
  THOUSAND: "Thousand",
  THOUSAND_NO_CAPITAL: " thousand",
  MILLION_NO_CAPITAL: " million",
  MILLIONS_NO_CAPITAL: " millions",
  BILLION_NO_CAPITAL: " billion",
  BILLIONS_NO_CAPITAL: " billions",
  LAST_EVENT: "Last event: ",
  UP_TIME: "Uptime:",
  MONITORING: "Monitoring: ",
  TURNED_OFF: "Turned off ",
  TURNED_ON: "Turned on ",
  MONITORING_ON_TOOLTIP: "Monitoring service turned on.",
  MONITORING_OFF_TOOLTIP: "Monitoring service turned off. To turn on the service, access the MONITORING page inside the Settings tab.",
  MONITORING_GETTING_CONNECTION: "Establishing connection.",
  ZERO_IP: "0.0.0.0",

  ALARMS_QUESTION_INFO: "Indicates the number of alarms the device say it has. Alarms indicate abnormal device status conditions such as short circuit, power supply problems, missing modules, etc.",
  FAULTS_QUESTION_INFO: "Indicates the number of times that a PROFINET device did not respond to messages sent by TS Monitor.",

  AVAILABILITY_QUESTION_INFO_1: "Indicates the percentage of time the device was detected on the network, that is, it was accessible via the network.",
  AVAILABILITY_QUESTION_INFO_2: "This parameter does not take into account any other conditions like whether the device was working or not, but rather the fact that it responds to TS Monitor.",

  SHOW_ONLY_ERROR_DEVICES: "Show only devices with errors",

  PORTS_FILTER_LABEL: "Ports filter",
  PORTS_FILTER_POPUP_1: "Some devices present packet losses on internal ports for which there is no corrective action possible by the user, and do not bring relevant information for analysis of the network itself.",
  PORTS_FILTER_POPUP_2: "The filter eliminates these ports, however ports with unusual names can be eliminated and for this reason the filter can be turned off to allow a full overview.",

  PORTS_FILTER_TURN_ON_FAILURE: "An error occurred while turning on the ports filter.",
  PORTS_FILTER_TURN_OFF_FAILURE: "An error occurred while turning off the ports filter.",

  DEVICE: "Device",

  LIVE_LIST_OK_POPUP_TEXT: "The device is operating normaly, that is, it is exchanging data.",
  LIVE_LIST_DIAGNOSTIC_POPUP_TEXT: "A device that is operating normaly has signaled a diagnostic condition.",
  LIVE_LIST_FAULT_POPUP_TEXT: "A device that was in normal operating mode (OK) is no longer communicating on the PROFINET network, and is, therefore, at a fault state.",
  LIVE_LIST_ONLINE_POPUP_TEXT: "The device is physically on the PROFINET network and does not exchange data with the controller. This behavior is due to the fact that the device is not active or configured in the controller's project.",
  LIVE_LIST_OFFLINE_POPUP_TEXT: "An Ethernet device that has been disconnected from the network.",
  LIVE_LIST_DUPLICATE_IP_POPUP_TEXT: "When more than one device has the same IP address.",
  LIVE_LIST_DUPLICATE_IP_POPUP_TEXT_2: "By clicking on the cell you can delete the device, if you want.",
  LIVE_LIST_BLACKLIST_POPUP_TEXT: "The user can put an IO Device in Blacklist mode, in order to not generate repetitive events in the Log.",
  LIVE_LIST_CONFIG_ERROR_POPUP_TEXT: "Device with different ID numbers between a configured and physically installed module (information taken from the device's GSDml). The description is presented in the log in more detail.",

  LIVE_LIST_CSV_HEADER: "Name,Tag,MAC,IP,Alarms,Faults,Current ping (ms),Average ping (ms),Lost pings,Lost pings (%),Availability,Status\n",
  LIVE_LIST_CSV_EXPORT_NAME: "Live List.xlsx",

  PS: "Note:",

  IP_POPUP_2: "If the device loses its IP address, it will have an orange background, as in the example below.",
  IP_POPUP_3: "Furthermore, by clicking on the cell you can delete the device, if you want.",

  REMOVE_LOST_IP_MODAL_HEADER: "Remove device with IP address loss",
  REMOVE_LOST_IP_MODAL_CONTENT_1: "Are you sure you want to remove the device with IP address: 0.0.0.0?",
  REMOVE_LOST_IP_MODAL_CONTENT_2: "If the device still has a loss of IP address, it will be added back to the Live List in the next TS Monitor PROFINET search cycle.",

  // ---------------------------- GRAPHIC TOPOLOGY ----------------------------
  SAVE_TOPOLOGY_POS_STRING: "Save",
  DELETE_TOPOLOGY_POS_STRING: "Remove",
  EXPORT_SVG: "SVG",
  EXPORT_TOPOLOGY: "Topology",
  IMPORT_TOPOLOGY: "Import Topology",
  IMPORT: "Import",
  EXPORT_PNG: "PNG",
  POSITION: "Position",
  EXPORT: "Export",
  FILTER: "Filters",
  EXPORT_SVG_POPUP_MSG_1: "To export the topology image in SVG format it is necessary to first save the topology position.",
  EXPORT_SVG_POPUP_MSG_2: "To export the topology image in SVG format it is necessary to first save the topology position, as shown in the image bellow:",
  EXPORT_SVG_POPUP_MSG_3: "Before clicking the SVG button, make sure that all network devices are displayed inside the rectangle, as shown in the figure below:",
  EXPORT_SVG_POPUP_MSG_4: "If any device is outside the viewing area, as shown in the following figure, it will not appear in the SVG file:",

  HIGHER_THAN_20_MBPS: "> 20 Mbps",
  HIGHER_THAN_50_MBPS: "> 50 Mbps",
  WITH_ERROR: "With error",
  WITH_ERROR_INCREMENT: "With &Delta; error",
  LEGEND: "Legend",

  SAVE_TOPOLOGY_POS_SUCCESS_STRING: "The topology positioning was saved successfully!",
  SAVE_TOPOLOGY_POS_FAILURE_STRING: "The following error occurred while saving the topology positioning: ",

  DROP_TOPOLOGY_POS_SUCCESS_STRING: "The topology positioning was removed successfully!",
  DROP_TOPOLOGY_POS_FAILURE_STRING: "The following error occurred when removing topology positioning: ",

  DROPDOWN_NONE: "None",
  DROPDOWN_TRAFFIC: "Traffic",
  DROPDOWN_ERRORS: "Errors",

  ASK_REMOVE_POSITIONING: "Are you sure you want to remove the currently saved positioning? To confirm the removal it is necessary to enter the login information.",
  REMOVE_POSITIONING: "Remove positioning",
  GRAPHIC_TOPOLOGY_WAITING: "Loading graphic topology",
  YES: "Yes",
  NO: "No",
  USERNAME_PWD_EMPTY: "The username and password cannot be blank.",

  FORM_INPUT_NOT_FOUND_1: "The device of IP: ",
  FORM_INPUT_NOT_FOUND_2: " was not found",
  FORM_INPUT_INVALID_IP: "Enter a valid ip address",

  DUPLICATE_IPS: "Unable to load graphical topology as the network contains duplicate IPs.",

  DISCONNECTED_PORT_1: "The selected port ",
  DISCONNECTED_PORT_2: " of the device ",
  DISCONNECTED_PORT_3: " is no longer connected to anyone.",

  TOPOLOGY_IMPORT_SUCCESS: "The topology was imported successfully!",
  ERROR_IMPORTING_GRAPHIC_TOPOLOGY: "An error occurred while importing the graphical topology: ",
  INVALID_OR_CORRUPT_FILE: "The file is not valid or is corrupt.",
  PLEASE_SELECT_TOPOLOGY_FILE: "Please select a topology file.",

  GRAPHIC_TOPOLOGY_POPUP_1: "The graphic topology is automatically detected according to information received from the network devices and presents the equipment status according to the Live List colors and the links between the devices change from blue to orange when they present an error increment.",
  GRAPHIC_TOPOLOGY_POPUP_2: "Some devices do not respond to SNMP commands used for this detection, thus, not all devices shown in the Live List will be present in the graphical topology.",
  GRAPHIC_TOPOLOGY_POPUP_3: "The different icons shown depend on the inclusion of the GSDml configuration files in the TS Monitor settings tab (this file must correspond to the device present on the network, otherwise the icon corresponding to the type will not appear).",
  GRAPHIC_TOPOLOGY_POPUP_4: "It is possible to change the equipment positions, but it is not possible to change the connection between them, or add an equipment.",

  NAME_DP: "Name: ",
  MODEL_DP: "Model: ",
  PROFINET_TOPOLOGY_JSON: "PROFINET Topology.json",

  // ---------------------------- Log ----------------------------
  ALARM_FAILURE_TOOLTIP: "Maintenance must be performed now. The device is no longer working.",
  ALARM_MAINTENANCE_DEMANDED_TOOLTIP: "Maintenance should be performed as soon as possible.",
  ALARM_MAINTENANCE_REQUIRED_TOOLTIP: "The device requires predictive maintenance.",
  ALARM_NONE_TOOLTIP: "Unreported severity.",
  INSERT_VALID_EVENT_OR_NAME_OR_IP: "Please enter a valid event, name or IP.",
  MANUFACTURER_TIP: " (Manufacturer's tip: ",
  FROM_GSDML: "From GSDML: ",
  STATUS_CHANGE: "State change: ",
  DUPLICATE_IP: "Duplicate IP: ",
  DUPLICATE_NAME_DP: "Duplicate profiname: ",

  // ---------------------------- BLACKLIST ----------------------------
  UPDATE_BLACKLIST_DEVICES: "Update blacklist devices",
  CONFIRM_UPDATE_BLACKLIST_MODAL_TEXT: "Are you sure you want to update the blacklisted devices?",

  ADD_DEVICES_TO_BLACKLIST: "Add devices to blacklist",
  REMOVE_DEVICES_FROM_BLACKLIST: "Remove devices from blacklist",
  BLACKLIST_FORM_INPUT_PLACEHOLDER: "Filter devices by name, MAC or IP",
  BLACKLIST_NAME: "Name",
  BLACKLIST_MODEL: "Model",
  BLACKLIST_MAC: "MAC",
  BLACKLIST_IP: "IP",
  SELECT_ALL: "Select all",
  REMOVE_SELECTED: "Remove selected",
  ADD_SELECTED: "Add selected",
  ADD_DEVICES_TO_BLACKLIST_SUCCESS: "The devices have been added to the blacklist successfully.",
  ADD_DEVICES_TO_BLACKLIST_FAILURE: "An error occurred while adding the following devices to the blacklist:",
  REMOVE_DEVICES_FROM_BLACKLIST_SUCCESS: "The devices were removed from the blacklist successfully.",
  REMOVE_DEVICES_FROM_BLACKLIST_FAILURE: "An error occurred while removing the following devices from the blacklist:",
  SELECT_AT_LEAST_ONE_DEVICE: "Select at least one device to add to the blacklist.",
  CONFIRM_ADD_TO_BLACKLIST_MODAL_TEXT: "Are you sure you want to add the selected devices to the blacklist?",
  CONFIRM_REMOVE_FROM_BLACKLIST_MODAL_TEXT: "Are you sure you want to remove selected devices from the blacklist?",
  IGNORE: "Ignore",
  LOG_IGNORE: "Log",
  QUESTION_IGNORE: "Monitoring",
  FAULTS_IGNORE: "Faults",
  ALARMS_IGNORE: "Alarms",
  AVAILABILITY_IGNORE: "Availability",
  SNMP_IGNORE: "SNMP",

  UPDATE_BLACKLIST: "Update blacklist",
  UPDATING_BLACKLIST_WAITING: "Updating the blacklist, wait a moment",
  UPDATING_BLACKLIST_SUCCESS: "The blacklist has been updated successfully",
  BLACKLIST: "Blacklist",

  WHAT_DOES: "What it does: ",
  HOW_DOES_IT_APPLY: "How it applies: ",

  DELTA_ERRORS_TOOLTIP_WHAT: "It does not check in TS Expert if this device has errors increment, but it continues counting in the traffic tab.",
  DELTA_ERRORS_TOOLTIP_HOW: "Useful for RFIDs, Access Points and devices with intrinsic data loss.",

  LOG_TOOLTIP_WHAT: "Counts alarms and faults, but does not insert them in the log.",
  LOG_TOOLTIP_HOW: "Devices that have abnormal conditions that cannot be resolved.",

  MONITORING_TOOLTIP_WHAT: "Does not send any kind of requests to the device.",
  MONITORING_TOOLTIP_HOW: "Some devices may show abnormal behaviour for continuous monitoring systems, and may present failures.",

  FAULTS_TOOLTIP_WHAT: "Does not check in TS Expert if this device has faults, but it continues logging and counting in the Live List and Log tabs.",
  FAULTS_TOOLTIP_HOW: "Commonly used in devices that present normal alarms during the process, such as AGVs and other devices that use fast startup.",

  ALARMS_TOOLTIP_WHAT: "Does not check in TS Expert if this device has alarms, but continues logging and counting in the Live List and Log tabs.",
  ALARMS_TOOLTIP_HOW: "Commonly used in devices that present normal alarms during the process, such as AGVs and other devices that use fast startup.",

  AVAILABILITY_TOOLTIP_WHAT: "Disregards the device for availability calculation.",
  AVAILABILITY_TOOLTIP_HOW: "It can be used for PROFINET and Ethernet devices taking into account the criticality of the device to the process.",

  SNMP_TOOLTIP_WHAT: "It considerably reduces sending SNMP queries to the device.",
  SNMP_TOOLTIP_HOW_1: "There are cases where devices with low throughput are overloaded when answering SNMP queries.",
  SNMP_TOOLTIP_HOW_2: "When placing TS Monitor PROFINET on the network, if it is detected that a device is not operating correctly, adding it to this blacklist will considerably reduce the rate at which SNMP queries are sent, and may solve the problem.",

  BLACKLIST_UPDATE_ERROR: "An error occurred while saving the blacklist information, please try again",
  BLACKLIST_UPDATE_SUCCESS: "Blacklist was updated successfully",

  REQUEST_TOOK_TOO_LONG: "The connection took too long to respond.\n",
  UNABLE_TO_UPDATE_FOLLOWING_BLACKLISTS: "Unable to update the following blacklist information:\n",
  TRY_AGAIN_STRING: "Please try again.\nOBS: The information of other blacklists was updated normally.",
  ERROR_LIST_DELTA_ERRORS: "- Delta erros;\n",
  ERROR_LIST_LOG: "- Log;\n",
  ERROR_LIST_FAULTS: "- Faults;\n",
  ERROR_LIST_ALARMS: "- Alarms;\n",
  ERROR_LIST_AVAILABILITY: "- Availability;\n",
  ERROR_LIST_MONITORING: "- Monitoring;\n",
  ERROR_LIST_SNMP: "- SNMP;\n",

  DEVICES_FROM_BLACKLIST_POPUP_1: "Monitoring blacklisted devices appear on other screens with a black status color",
  DEVICES_FROM_BLACKLIST_POPUP_2: "Devices from other blacklists will appear on other screens with their normal status colors",
  DEVICES_FROM_BLACKLIST_POPUP_3: "Monitoring blacklist devices appear in black color",
  DEVICES_FROM_BLACKLIST_POPUP_4: "Devices from other blacklists appear with their normal status colors",

  // ---------------------------- Edit GSDML page related ----------------------------
  REMOVE_GSDML_SUCCESS: "GSDML files were removed successfully",
  REMOVE_GSDML_FAILURE: "An error occurred while removing the GSDML files",
  REMOVE_GSDML_FILES: "Manage GSDML files",
  FILTER_GSDML: "Filter GSDML files",
  REMOVING_GSDML_FILES: "Removing GSDML files",

  // ---------------------------- Device Search related ----------------------------
  MANUAL_SEARCH: "Manual Search",
  SEARCH_DEVICES: "Search devices",
  MANUAL_SEARCH_TURNED_ON_SUCCESS: "Manual search has been turned on successfully.",
  MANUAL_SEARCH_TURNED_OFF_SUCCESS: "Manual search was turned off successfully.",
  ERROR_ALTERING_SEARCH_STATE: "An error occurred while changing the search state.",
  CHOOSE_SEARCH_QUANTITY: "Please choose the number of searches to be performed.",
  DEVICE_SEARCH_INIT_SUCCESS: "The device search has started successfully.",
  DEVICE_SEARCH_INIT_FAILURE: "An error occurred while starting the device search.",
  SEARCH: "Search",
  SEARCH_NOUN: "Search",
  SEARCH_MODE: "Search mode",
  MANUAL_SEARCH_TURNED_OFF: "Turned off",
  MANUAL_SEARCH_TURNED_ON: "Turned on",
  QUANTITY_OF_NEW_SEARCHES: "Number of new searches",
  ERROR_FETCHING_SEARCH_STATE: "An error occurred while accessing the search state.",

  // ---------------------------- PORTS ----------------------------
  PORTS: "Ports",

  DUPLEX_MODE_1: "Duplex",
  DUPLEX_MODE_2: "Mode",

  INTERFACE_SPEED_1: "Interface",
  INTERFACE_SPEED_2: "speed",

  LINE_DELAY_VALUE_1: "Delay",
  LINE_DELAY_VALUE_2: "Value",

  ACTIVE: "Active",
  INACTIVE: "Inactive",

  // ---------------------------- Ping ----------------------------
  MEDIUM_PING: "Average ping",
  LOST_PACKET_PERC_1: "Lost",
  LOST_PACKET_PERC_2: "Pings (%)",
  TENDENCY: "Tendency",
  EXPORT_CSV: "Export XLSX",
  MISSED_PINGS_POPUP: "Quantity / % of lost pings in the last 360 pings performed.",

  // ---------------------------- Ping Graph ----------------------------
  DEVICES_TOOLTIP_1: "You can view a maximum of 5 devices at the same time.",
  DEVICES_TOOLTIP_2: "Duplicate IP devices are not shown until the issue is resolved.",
  TIME_DP: "Time: ",
  TIME: "Time",
  PING: "Ping",
  PING_GRAPH: "Ping graph",

  // ---------------------------- WLAN Config ----------------------------
  WLAN_STATUS: "WLAN adapter",
  WLAN_CONFIG: "WLAN settings",
  CONNECTION_STATUS: "Connection state",

  WLAN_ADAPTER_ON: "Turned on",
  WLAN_ADAPTER_OFF: "Turned off",

  IP_PLACEHODLER: "192.168.2.215",
  SSID: "SSID",
  SIGNAL_STRENGTH: "Signal strength",
  FREQUENCY: "Frequency",
  CHANNEL: "Channel",
  QUALITY: "Quality",

  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH_PLACEHOLDER: "90 dBm",
  FREQUENCY_PLACEHOLDER: "2.4GHz",
  CHANNEL_PLACEHOLDER: "1",
  QUALITY_PLACEHOLDER: "Quality",

  TURNING_WLAN_OFF_WAITING: "Turning off the WLAN adapter, please wait.",
  TURNING_WLAN_ON_WAITING: "Turning on the WLAN adapter, please wait.",

  NETWORK: "Network",
  NETWORK_NAME_1: "Network name",
  SUBMASK: "Mask",
  GATEWAY: "Gateway",
  DNS: "DNS",
  TAG: "Tag",
  PASSWORD: "Password",
  SETUP: "Setup",
  YEAR: " year",
  MONTH: " month",
  MONTHS: " months",
  DAY: " day",
  HOUR: " hour",
  MINUTE: " minute",
  SECOND: " second",

  ALTER_MONITOR_WLAN_CONFIG: "Are you sure you want to change the monitor's WLAN settings?",
  ALTER_OFFICE_INTERFACE_CONFIG_HEADER: "Configure office interface",
  ALTER_OFFICE_INTERFACE_CONFIG: "Are you sure you want to change the office interface configuration?",
  ALTER_OFFICE_INTERFACE_CONFIG_2: "When using DHCP mode, make sure that the office interface will not be configured in the same subnet as the PROFINET interface, otherwise the TS Monitor PROFINET may behave differently than expected.",

  CONNECTED: "Connected",
  DISCONNECTED: "Disconnected",

  WLAN_STATUS_POPUP_1: "Indicates the status of the monitor's WLAN adapter.",
  WLAN_STATUS_POPUP_2: "If it is turned off it is not possible to change the WLAN settings.",

  CONNECTION_STATUS_POPUP_1: "Indicates whether or not the monitor is connected to the configured WLAN network.",
  CONNECTION_STATUS_POPUP_1_1: "Indicates whether or not the monitor is connected to the configured Ethernet network.",

  WLAN_CONFIG_POPUP_1: "It is not possible to change the settings while the WLAN adapter is turned off.",
  WLAN_CONFIG_POPUP_2: "It is highly recommended that the WLAN settings be changed only when accessing the monitor via the wired network.",
  WLAN_CONFIG_POPUP_3: "When changing the IP / mask, if the fields appear blank after the update this is a strong indication that:",
  WLAN_CONFIG_POPUP_4: "There is already another device on the network with the same IP;",
  WLAN_CONFIG_POPUP_5: "The netmask is too strict and does not support the IP that was entered.",

  WLAN_ADAPTER_NOT_FOUND_1: "TS Monitor PROFINET could not find the WLAN adapter:\n",
  WLAN_ADAPTER_NOT_FOUND_2: "  • Check if the adapter is disconnected, or with bad contact;\n",
  WLAN_ADAPTER_NOT_FOUND_3: "  • If the adapter is not disconnected and it doesn't have bad contact, try to replace it.;\n",
  WLAN_ADAPTER_NOT_FOUND_4: "  • If none of the previous options solves the problem, contact Toledo e Souza.",

  HOSTNAME_POPUP_1: "A hostname must be between 2 and 64 characters to be valid.",
  HOSTNAME_POPUP_2: "Also, it can only contain letters, numbers, periods and hyphens, and it must start and end with only letters and numbers.",

  INVALID_HOSTNAME_1: "The hostname must be between 2 and 64 characters long.",
  INVALID_HOSTNAME_2: "The hostname must contain only letters, numbers, periods and hyphens, and must start and end with only letters and numbers.",

  HOSTNAME_CONFIG_SUCCESS: "The hostname has been configured successfully.",
  HOSTNAME_CONFIG_ERROR: "There was an error configuring the hostname",
  MODE: "Mode",
  HIDDEN_SSID: "Hidden SSID",
  OPTIONAL: " (Optional)",
  FIXED_IP: "Fixed IP",

  // ---------------------------- INVENTORY ----------------------------
  INVENTORY_INPUT_TEXT_PLACEHOLDER: "Filter by IP, MAC, name or model",
  MANUFACTURER: "Manufacturer",
  ORDER_NUMBER: "Order number",
  VERSION_OF: "version",
  IO_CONTROLLER_POPUP_1: "This column shows which IO Controllers the device is associated with.",
  IO_CONTROLLER_POPUP_2: "It is possible that the device is:",
  IO_CONTROLLER_POPUP_3: "Associated with an IO Controller;",
  IO_CONTROLLER_POPUP_4: "Associated with more than one IO Controller;",
  IO_CONTROLLER_POPUP_5: "Not associated with any IO Controller.",

  DEVICE_COUNTERS_POPUP: "The numbers on the side indicate the totals for each type of equipment.",

  NO_IO_CONTROLLER: "Not associated",
  ASSOCIATED: "associated",
  ORDER_NUMBER_N: "Order\nnumber",
  HARDWARE_VERSION_N: "Hardware\nVersion",
  FIRMWARE_VERSION_N: "Firmware\nVersion",
  IO_CONTROLLER: "IO Controller",

  INVENTORY_CSV_HEADER: "Name,MAC,IP,Role,Model,Manufacturer,Order number,Hardware version,Firmware version,Associated IO Controller\n",
  INVENTORY_EXPORT_NAME: "Inventory.xlsx",

  // ---------------------------- TS EXPERT CONFIG ----------------------------
  CURRENT_VALUE_DP: "Current value: ",
  SAVE: "Save",
  SENDING_TS_EXPERT_CONFIG_WAITING: "Updating TS Expert settings, please wait a moment.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "TS Expert settings have been saved successfully.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "An error occurred while saving the TS Expert settings.",

  TS_EXPERT_CONFIGURATION: "TS Expert Settings",

  CONFIG_DIAGNOSTIC_LIST_HEADER: "Alarms",
  CONFIG_DIAGNOSTIC_LIST_CONTENT: "If on, TS Expert will log every time a PROFINET device has alarms. Alarm is an abnormal condition or malfunction information sent by the IO Device to the IO Controller, requesting maintenance or even replacement.",

  CONFIG_FAULT_LIST_HEADER: "Faults",
  CONFIG_FAULT_LIST_CONTENT: "If on, TS Expert will log every time a PROFINET device has faults. This indicates that it is not responding to ping and arp commands over the network, that is, it is not accessible via the network.",

  CONFIG_DUPLICATE_NAME_LIST_HEADER: "Duplicate profiname",
  CONFIG_DUPLICATE_NAME_LIST_CONTENT: "If on, TS Expert will log every time two devices are configured with the same profiname. This can cause issues during communication.",

  CONFIG_DUPLICATE_IP_LIST_CONTENT: "If on, TS Expert will log each time a duplicate IP is detected on the network.",

  CONFIG_EXCEEDED_PING_LIST_HEADER: "Ping limit exceeded",
  CONFIG_EXCEEDED_PING_LIST_CONTENT: "If on, TS Expert will log every time the average ping of a device exceeds the ping limit value.",

  CONFIG_ERROR_INCREMENT_LIST_HEADER: "Errors increment",
  CONFIG_ERROR_INCREMENT_LIST_CONTENT: "If on, TS Expert will register every time a device has an increment of packets with input and/or output errors on any of its ports.",

  CONFIG_DUPLEX_LIST_HEADER: "Port configured in a Duplex mode and/or speed not recommended",
  CONFIG_DUPLEX_LIST_CONTENT: "If on, TS Expert will log every time a port configuration is different from: Full Duplex at 100 Mbps or Full Duplex at 1000 Mbps (Ports configured in Half Duplex tend to generate collisions and packet loss, which is a problem for a real-time data exchange and control protocol. Links configured at 10 Mbps can become communication bottlenecks and prevent packet transmission).",

  CONFIG_TRAFFIC_EXCEEDED_LIST_HEADER: "Too much inbound/outbound traffic",
  CONFIG_TRAFFIC_EXCEEDED_LIST_CONTENT: "If on, TS Expert will log whenever a total traffic greater than 50 Mbps is detected on a given port.",

  CONFIG_INACTIVE_PORT_LIST_HEADER: "Inactivated port",
  CONFIG_INACTIVE_PORT_LIST_CONTENT: "If on, the TS Expert will log each time an active port is disabled, either by disconnecting or breaking a cable, or by turning off or disconnecting the device at the opposite end of the cable. It could indicate a problem with the cable, connector, the device on the opposite end, or even the electronics of the device that had the port disabled.",

  HW_FW_PORT_LIST_HEADER: "Same hardware version and different firmware versions",
  HW_FW_PORT_LIST_CONTENT: "If on, TS Expert will log every time devices with the same hardware versions but different firmware versions are detected. These devices may have different functionality, characteristics and behavior. This indicator aims to cross information about faults that may be occurring in isolation in one or another device and that may be related to firmware versions.",

  CONFIG_ERROR_CONFIG_LIST_HEADER: "Module different from the one that was configured",
  CONFIG_ERROR_CONFIG_LIST_CONTENT: "If on, TS Expert will log every time a module different from the configured one is detected. This configuration fault happens when the module declared in the configuration software is different from the one physically installed in the IO Device.",

  DUPLEX_MISMATCH_CONFIG_LIST_HEADER: "Duplex mode incompatibility",
  DUPLEX_MISMATCH_CONFIG_LIST_CONTENT: "If on, the TS Expert will register all the links that returned with Duplex information and are incompatible with each other, for example, a Half Duplex port connected to another port in Full Duplex.",

  DELAY_EXCEEDED_CONFIG_LIST_HEADER: "Delay",
  DELAY_EXCEEDED_CONFIG_LIST_CONTENT: "When this option is enabled, TS Expert will log all links that returned with link or cable delay values greater than those recommended by PROFINET guidelines.",

  CONFIG_INTERMITTENT_FAILURE_LIST_HEADER: "Intermittent faults",
  CONFIG_INTERMITTENT_FAILURE_LIST_CONTENT: "If on, TS Expert will log intermittent faults from PROFINET devices. This indicates that the IO Device is losing communication and recovering quickly.",

  CONFIG_LOST_IP_LIST_HEADER: "IP address loss",
  CONFIG_LOST_IP_LIST_CONTENT: "If turned on, TS Expert will log every time a device with a possible loss of IP address is detected (0.0.0.0).",

  PING_LIMIT: "Ping limit",
  ALTER_PING_LIMIT_SUCCESS: "The ping limit was successfully changed.",
  ALTER_PING_LIMIT_ERROR: "An error occurred while changing the ping threshold.",

  PING_LIMIT_POPUP_1: "The ping limit is the average ping value above which the device is considered to have a problem. If this occurs, an event will be created in TS Expert.",
  PING_LIMIT_POPUP_2: "Every time a device exceeds this value an event will be created in TS Expert.",
  PING_LIMIT_POPUP_3: "The ping measurement unit is milliseconds (ms).",
  PING_LIMIT_POPUP_4: "The minimum value allowed for the ping limit is 0 ms.",
  PING_LIMIT_POPUP_5: "The maximum value allowed for the ping limit is 10.000 ms (10 seconds).",

  PING_LIMIT_OUT_OF_BOUNDS: "The ping limit must be between 0 and 10.000 ms (10 seconds).",

  // ---------------------------- TS EXPERT ----------------------------
  TS_EXPERT_REPORT_EXPORT_NAME: "Actions list - TS Expert - PROFINET",

  TS_EXPERT_POPUP_1: "This tab displays the TS Expert information.",
  TS_EXPERT_POPUP_2: "This tool is an expert system developed to optimize and accelerate the analysis of the main divergences detected by TS Monitor in PROFINET networks.",
  TS_EXPERT_POPUP_3: "In an automated way, maintenance, engineering and related teams can obtain a list of actions with different events, their possible causes, solution suggestions and the devices on which they were detected.",
  TS_EXPERT_POPUP_4: "The use of TS Expert does not exclude the need for human analysis, nor does it replace such capabilities to create data correlations and interpretation.",

  TS_EXPERT: "TS Expert",
  DETECTED_ON: "Detected in: ",
  CHECK_YOUR_NETWORK: "Please check your network.",

  EXPORT_ACTIONS_LIST: "Export actions list",
  GENERATING_ACTIONS_LIST_WAITING: "Generating actions list PDF, please wait.",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF generated successfully. To save it, click on save actions list.",

  EVENTS_LIST: "Events list",
  ACTIONS: "Actions",

  NO_PROBLEM_DETECTED: "TS Expert has not detected any events on the network.",
  NO_EVENTS_TO_BE_ANALYZED: "There are no events to be analyzed.",

  NO_EVENT_SELECTED: "No event selected",
  CHOOSE_AN_EVENT: "Choose an event to view suggested actions.",

  DETAILING: "Detailing",

  CHECKED: "Check",
  BATCH_CHECK: "Check all",

  PROBLEM_CHECKED: "The event was successfully checked",
  PROBLEM_CHECK_ERROR: "An error occurred while checking the event.",

  QUANTITY_DP: "Quantity: ",
  INCREMENTS: "Increments",

  PORT_IS_STILL_INACTIVE: "The port is still inactive",
  MARK_PROBLEM_AS_SOLVED: "Are you sure you want to mark the event as checked?",

  LAST_UPDATED: "Last updated on: ",
  THIS_COMPUTER_TIME: " (This computer's time)",

  RECEIVED_INFO: "Received information",
  EXPECTED_INFO: "Expected information",

  RECEIVED_INFO_DP: "Received information:",
  EXPECTED_INFO_DP: "Expected information:",

  MODULE_NUMBER_DP: "Module name:",
  ALL_EVENTS_WERE_CHECKED: "All events have been successfully checked.",
  CHECK_EVENT_OBS: "\nIt is important to note that some data take up to 15 minutes to be updated, therefore, it is suggested to wait some time to clear this list by clicking on check.\n",
  ACTIONS_LIST_NAME: "Actions list - TS Expert - PROFINET.pdf",
  SAVE_ACTIONS_LIST: "Save actions list",
  ACTIONS_LIST: "Actions list",

  UNABLE_TO_CHECK_ALARMS_EVENT: "Unable to check device event as it still has active alarms\n",
  UNABLE_TO_CHECK_FAULT_EVENT: "Unable to check device event as it is still in fault state\n",
  UNABLE_TO_CHECK_DUPLICATE_IP_EVENT: "Unable to check device event as it still has duplicate IP\n",
  UNABLE_TO_CHECK_DUPLICATE_NAME_EVENT: "Unable to check device event as it still has duplicate profiname\n",
  UNABLE_TO_CHECK_PING_LIMIT_EVENT: "Unable to check device event as the average ping value remains above the configured ping limit value\n",
  UNABLE_TO_CHECK_DELTA_ERROR_EVENT: "Unable to check device event as it has ports with error increments\n",
  UNABLE_TO_CHECK_NOT_IN_FULL_DUPLEX_EVENT: "Unable to check device event as its port is still configured in a non-recommended duplex mode and/or speed\n",
  UNABLE_TO_CHECK_TRAFFIC_EXCESS_EVENT: "Unable to check device event as traffic on the following ports still exceeds 50 Mbps\n",
  UNABLE_TO_CHECK_INACTIVE_PORT_EVENT: "Unable to check device event because its port remains inactive (was active and now is inactive)\n",
  UNABLE_TO_CHECK_HW_FW_EVENT: "Unable to check the event, as the devices still have the same hardware versions, but different firmware versions\n",
  UNABLE_TO_CHECK_MODULE_INCOHERENCE_EVENT: "Unable to check the device event as it still has modules different from the ones declared in the configuration software\n",
  UNABLE_TO_CHECK_DUPLEX_MISMATCH_EVENT: "Unable to check the device event as it still has Duplex mode incompatibility\n",
  UNABLE_TO_CHECK_DELAY_EXCEEDED_EVENT: "Unable to check the device event as its port still exceeds delay limit value\n",
  UNABLE_TO_CHECK_INTERMITTENT_FAILURE_EVENT: "Unable to check device event as it is still has intermittent faults\n",
  UNABLE_TO_CHECK_LOST_IP_EVENT: "Unable to check the device event, as it still presents a possible loss of IP address\n",

  UNABLE_TO_CHECK_ALARMS_EVENTS: "Unable to check events from the following devices as they still have active alarms:\n",
  UNABLE_TO_CHECK_FAULT_EVENTS: "Unable to check the events of the following devices as they are still in a fault state:\n",
  UNABLE_TO_CHECK_DUPLICATE_IP_EVENTS: "Unable to check the events of the following devices as they still have a duplicate IP:\n",
  UNABLE_TO_CHECK_DUPLICATE_NAME_EVENTS: "Unable to check events for the following devices as they are still duplicated:\n",
  UNABLE_TO_CHECK_PING_LIMIT_EVENTS: "Unable to check the events of the following devices as the average ping values are still above the configured ping limit value:\n",
  UNABLE_TO_CHECK_DELTA_ERROR_EVENTS: "Unable to check events for the following devices as they have ports with error increments:\n",
  UNABLE_TO_CHECK_NOT_IN_FULL_DUPLEX_EVENTS: "Unable to check the events of the following devices as their ports are still configured in a non-recommended duplex mode and/or speed:\n",
  UNABLE_TO_CHECK_TRAFFIC_EXCESS_EVENTS: "Unable to check the events of the following devices as traffic on these ports still exceeds 50 Mbps:\n",
  UNABLE_TO_CHECK_INACTIVE_PORT_EVENTS: "Unable to check the events of the following devices because their ports are still inactive (they were active and now are inactive):\n",
  UNABLE_TO_CHECK_HW_FW_EVENTS: "Unable to check the events of the following devices, as they still have the same hardware versions, but different firmware versions:\n",
  UNABLE_TO_CHECK_MODULE_INCOHERENCE_EVENTS: "Unable to check the events of the following devices, as they still have modules different from the ones declared in the configuration software:\n",
  UNABLE_TO_CHECK_DUPLEX_MISMATCH_EVENTS: "Unable to check the events of the following devices as they still have Duplex mode incompatibility:\n",
  UNABLE_TO_CHECK_DELAY_EXCEEDED_EVENTS: "Unable to check the events of the following devices as their ports still exceed the delay limit value:\n",
  UNABLE_TO_CHECK_INTERMITTENT_FAILURE_EVENTS: "Unable to check the events of the following devices as they are still have intermittent faults:\n",
  UNABLE_TO_CHECK_LOST_IP_EVENTS: "Unable to check the events of the following devices, as they still present a possible loss of IP address:\n",

  HARDWARE_VERSION: "Hardware version",

  // ---------------------------- DIAGNOSTICS ----------------------------
  DIAGNOSTIC_LIST_HEADER: "There are devices on the network that have alarms.",
  DEVICE_WITH_DIAGNOSTIC: "Device with alarm",

  DIAGNOSTIC_SUGGESTION_1: "When a device has alarms it is suggested to:",
  DIAGNOSTIC_SUGGESTION_2: "Check the information sent by the IO Device itself (detected and transformed into text by the TS Monitor) and try to solve the problem. If you have difficulty understanding the diagnosis, contact the device manufacturer or check the IO Device manual to clear your doubts before an intervention.",

  NO_DEVICE_WITH_DIAGNOSTIC: "There are no devices on the network with active alarms",

  // ---------------------------- FAULTS ----------------------------
  FAULTS_LIST_HEADER: "There are devices on the network that have faults.",
  DEVICE_WITH_FAULT: "Device with faults",

  FAULT_SUGGESTION_1: "When a device has faults, it is suggested to:",
  FAULT_SUGGESTION_2: "Check the IO Device power supply;",
  FAULT_SUGGESTION_3: "Check if it is physically connected to the network;",
  FAULT_SUGGESTION_4: "Check the connector's integrity;",
  FAULT_SUGGESTION_5: "Check the cable's integrity;",
  FAULT_SUGGESTION_6: "Check if the device has lost its IP address. If this happens, the device will appear on the monitor with the IP: 0.0.0.0, its IP will also be marked in orange in the Live List.",

  NO_DEVICE_WITH_FAULT: "There are no faulty devices on the network",

  // ---------------------------- DUPLICATE IP ----------------------------
  DUPLICATE_IP_LIST_HEADER: "There are devices on the network with duplicate IP.",
  DEVICES_WITH_DUPLICATE_IP: "Devices with duplicate IP",

  DUPLICATE_IP_CARD_DESC: "The devices below are using the IP address:",

  DUPLICATE_IP_SUGGESTION_1: "When there are duplicate IPs on the network, it is suggested to :",
  DUPLICATE_IP_SUGGESTION_2: "Check the physical addresses, MAC, to identify the devices that have IP address conflicts, and set appropriate IP addresses to them.",

  NO_DEVICES_WITH_DUPLICATE_IPS: "There are no devices on the network with duplicate IPs",

  // ---------------------------- DUPLICATE NAME ----------------------------
  DUPLICATE_NAME_LIST_HEADER: "There are devices on the network with duplicate profiname.",
  DEVICES_WITH_DUPLICATE_NAME: "Devices with duplicate profiname",

  DUPLICATE_NAME_CARD_DESC: "The devices below are using the name: ",

  DUPLICATE_NAME_SUGGESTION_1: "When there are devices on the network with duplicate profiname, it is suggested to:",
  DUPLICATE_NAME_SUGGESTION_2: "Check the project and change the IO Devices that have the wrong profiname.",

  NO_DEVICES_WITH_DUPLICATE_NAMES: "There are no devices on the network with duplicate profiname",

  // ---------------------------- PING LIMIT ----------------------------
  GROUP_PING_LIMIT_HEADER: "There are devices on the network that have exceeded the ping limit value.",
  PING_LIMIT_EXCEEDED: "Exceeded ping limit",

  REGISTERED_PING: "Registered ping: ",

  PING_LIMIT_SUGGESTION_1: "When a device exceeds the ping limit it is suggested to:",
  PING_LIMIT_SUGGESTION_2: "Traffic problems:",
  PING_LIMIT_SUGGESTION_3: "Use the Traffic tab and review the applications that are using the link, see if they are in accordance with the available infrastructure;",
  PING_LIMIT_SUGGESTION_4: "Check if the available bandwidth meets the application needs (using Fast or Gigabit Ethernet switches).",

  PING_LIMIT_SUGGESTION_5: "High utilization of equipment and switches processing:",
  PING_LIMIT_SUGGESTION_6: "Review application data consumption;",
  PING_LIMIT_SUGGESTION_7: "Check the temperature of the equipments.",

  PING_LIMIT_SUGGESTION_8: "Propagation delay (Excessive cable length):",
  PING_LIMIT_SUGGESTION_9: "Identify the length of the cable, visually when engraved on the cable, or using testers or certifiers.",

  NO_DEVICE_EXCEEDED_PING_LIMIT: "There are no devices on the network that have exceeded the ping limit value",

  // ---------------------------- DELTA ERROR ----------------------------
  DELTA_ERROR_LIST_HEADER: "There are devices on the network with ports that have error increments.",
  DELTA_ERROR_ALARM: "Error increments",
  DEVICE_HAS_DELTA_ERROR_PROBLEMS: "The device has error increments on the following ports:",

  DELTA_ERRORS_SUGGESTION_1: "When a device has ports that have error increments it is suggested:",
  DELTA_ERRORS_SUGGESTION_2: "In errors",
  DELTA_ERRORS_SUGGESTION_3: "Check for Duplex Mismatch (a 100 Mbps Full Duplex port connected to a 10 Mbps Half Duplex port). The links must have the same configuration on both ends and, preferably, use auto-negotiation;",
  DELTA_ERRORS_SUGGESTION_4: "Check if the data cable routes in cable trays, conduits and trays are close to power cabling, drives and other higher consumption devices whose cabling may generate interference. Network cables must be as far away as possible or in insulated and grounded conduits;",
  DELTA_ERRORS_SUGGESTION_5: "Check the quality of Ethernet links. Poorly assembled connectors, cables and poor quality connectors can generate losses;",
  DELTA_ERRORS_SUGGESTION_6: "Using a certifier, verify that the cables are intact and capable of performing for the category (Cat5, Cat5e, Cat6, etc.).",
  DELTA_ERRORS_SUGGESTION_7: "Out errors",
  DELTA_ERRORS_SUGGESTION_8: "Check for Duplex Mismatch (a 100 Mbps Full Duplex port connected to a 10 Mbps Half Duplex port). Links must have the same configuration on both ends and preferably use auto-negotiation;",
  DELTA_ERRORS_SUGGESTION_9: "Check the quality of Ethernet links. Poorly assembled connectors, cables and poor quality connectors can generate losses;",
  DELTA_ERRORS_SUGGESTION_10: "Check for possible problems with the device's network interface, requiring replacement if detected.",

  DEVS_WITH_DELTA_ERRORS_EXPLANATION_1: "This list only shows the devices and their ports that have input or output error increments.",
  DEVS_WITH_DELTA_ERRORS_EXPLANATION_2: "Error counters that have an increment will be highlighted in orange.",

  NO_DEVICE_WITH_DELTA_ERRORS_LIMIT: "There are no devices on the network with ports that have error increments",

  // ---------------------------- NOT IN FULL DUPLEX ----------------------------
  NOT_IN_FULL_DUPLEX_LIST_HEADER: "There are devices on the network with ports configured in a Duplex mode and/or speed that is not recommended.",
  PORT_NOT_IN_FULL_DUPLEX: "Port configured in a Duplex mode and/or speed not recommended",

  DUPLEX_MODE: "Duplex Mode",

  NOT_IN_FULL_DUPLEX_SUGGESTION_1: "When a port is configured in an unrecommended Duplex mode and/or speed it is suggested to:",
  NOT_IN_FULL_DUPLEX_SUGGESTION_2: "Check if the ports have the auto-negotiation function enabled. If it is fixed, it is suggested to change to a transmission rate of at least 100Mb and Duplex mode as Full Duplex.",
  NOT_IN_FULL_DUPLEX_SUGGESTION_3: "If the auto-negotiation option is enabled and the link remains in Half Duplex, it is suggested to change the cabling and, if this option does not lead to a Full Duplex negotiation, a network interface change might be the solution.",

  NO_DEVICES_WITHOUT_FULL_DUPLEX: "There are no devices on the network with ports configured in a Duplex mode and/or speed not recommended",

  // ---------------------------- TRAFFIC EXCESS ----------------------------
  TRAFFIC_EXCESS_LIST_HEADER: "There are devices on the network with ports that exceed 50 Mbps of traffic.",
  TRAFFIC_EXCESS: "Traffic exceeded 50 Mbps",
  DEVICE_HAS_TRAFFIC_EXCESS_ERROR_PROBLEMS: "The device has exceeded 50 Mbps of traffic on the following ports:",

  TRAFFIC_EXCESS_SUGGESTION_1: "When a device has ports that exceed 50 Mbps of inbound or outbound traffic:",
  TRAFFIC_EXCESS_SUGGESTION_2: "PROFINET guidelines indicate acceptable traffic of up to 20% (or 20Mbps on 100Mb links), traffic to be reviewed between 20 and 50% and the need for immediate action in case of traffic exceeding 50%. It is suggested to:",
  TRAFFIC_EXCESS_SUGGESTION_3: "Study the feasibility of increasing the response cycle time of IO Devices (consider process times, safety, etc);",
  TRAFFIC_EXCESS_SUGGESTION_4: "Split devices into different subnets and controllers;",
  TRAFFIC_EXCESS_SUGGESTION_5: "Analyze the topology and verify the possibility of creating new paths for a certain higher traffic, for example, adding switches;",
  TRAFFIC_EXCESS_SUGGESTION_6: "Check the origin of this traffic and if there is a need for this device to be communicating on the PROFINET network (isolate the devices that perform control from others that are used for maintenance, data collection or any other tasks that do not operate in real time).",

  DEVS_WITH_TRAFFIC_EXCESS_EXPLANATION_1: "This list only shows the devices and their ports whose inbound or outbound traffic exceeds 50 Mbps.",
  DEVS_WITH_TRAFFIC_EXCESS_EXPLANATION_2: "Traffic exceeding 50 Mbps will be highlighted in orange.",

  NO_DEVICE_WITH_TRAFFIC_EXCESS: "There are no devices on the network with ports that exceed 50 Mbps of traffic.",

  INPUT_TRAFFIC_KBPS: "In\ntraffic (Kbps)",
  OUTPUT_TRAFFIC_KBPS: "Out\ntraffic (Kbps)",

  // ---------------------------- INACTIVE PORT ----------------------------
  INACTIVE_PORT_LIST_HEADER: "There are devices on the network whose ports have been disabled.",
  INACTIVE_PORT: "Inactivated port",

  INACTIVE_PORT_SUGGESTION_1: "When a port is inactive (it was active and became inactive) it is suggested to:",
  INACTIVE_PORT_SUGGESTION_2: "Check cable and connector (at both ends), power supply to the device connected to the opposite end and cable breakage. As a last resort, it is suggested to replace the module.",

  NO_DEVICES_WITH_INACTIVE_PORTS: "There are no devices on the network that have inactive ports (was active and then became inactive)",

  // ---------------------------- HARDWARE / FIRMWARE ----------------------------
  HW_FW_LIST_HEADER: "There are devices on the network with the same hardware versions but different firmware versions.",
  HW_FW: "Same hardware versions and different firmware versions",
  SAME_HW_DIFF_FW: "The devices below have the same hardware versions, but different firmware versions",
  FIRMWARE: "Firmware",

  HW_FW_SUGGESTION_1: "When two devices have the same hardware version but different firmware versions it is suggested to:",
  HW_FW_SUGGESTION_2: "Update the firmware of these devices so that they are all the same to maintain the stability of the network and of the device's functionality.",
  HW_FW_SUGGESTION_3: "It is very important to perform this operation out of production and consult the device manufacturer before starting this task in order to avoid incompatibility and operation problems.",

  NO_DIFF_HW_FW: "There are no devices on the network with the same hardware versions, but different firmware versions.",

  // ---------------------------- MODULE INCOHERENCE ----------------------------
  MODULE_INCOHERENCE_LIST_HEADER: "There are devices on the network with modules different from those declared in the configuration software.",
  MODULE_INCOHERENCE: "Module different from the one declared in the configuration software",
  INCOHERENCE_IN_MODULE: "Difference detected in the following module",

  MODULE_INCOHERENCE_SUGGESTION_1: "When the device has modules different from those declared in the configuration software, it is suggested to:",
  MODULE_INCOHERENCE_SUGGESTION_2: "Check the configuration and installation in order to remedy the discrepancy reported by the device.",

  NO_DIFF_MODULES: "There are no devices on the network with modules other than those declared in the configuration software.",
  MODULE: "Module",

  // ---------------------------- DUPLEX MISMATCH ----------------------------
  DUPLEX_MISMATCH_LIST_HEADER: "There are devices on the network that have Duplex mode incompatibility.",
  DUPLEX_MISMATCH: "Duplex mode incompatibility",

  DUPLEX_MISMATCH_SUGGESTION_1: "When two devices have Duplex mode incompatibility it is suggested to:",
  DUPLEX_MISMATCH_SUGGESTION_2: "Check the configuration of the ports on both ends to verify if they are in auto-negotiation or if they are in a forced Duplex mode;",
  DUPLEX_MISMATCH_SUGGESTION_3: "If both ports are in auto-negotiation, it is suggested to test the integrity of the cabling;",
  DUPLEX_MISMATCH_SUGGESTION_4: "As a last resort, replace the device's network interface.",

  NO_DEVICES_WITH_DUPLEX_MISMATCH: "There are no devices on the network tthat have Duplex mode incompatibility.",

  // ---------------------------- DELAY EXCEEDED ----------------------------
  DELAY_EXCEEDED_LIST_HEADER: "There are devices on the network with delay alteration.",
  DELAY_EXCEEDED: "Delay alteration",

  DELAY_EXCEEDED_SUGGESTION_1: "When a device has a delay alteration, it is suggested:",
  DELAY_EXCEEDED_SUGGESTION_2: "In the case of an altered Cable Delay, it is suggested to verify the physical medium, certifying the links, checking the length of the cables (it can be identified by the metreage number recorded on the cable), proper assembly of connectors and quality and category (minimum Cat5) of the items used in this infrastructure;",
  DELAY_EXCEEDED_SUGGESTION_3: "In the case of an altered Line Delay, the same suggestion as before is valid and, if it does not bring results, it is suggested to replace the network interfaces, since this parameter indicates the times not only on the cable, but also on the receiver and transmitter;",

  // ---------------------------- INTERMITTENT FAULTS ----------------------------
  INTERMITTENT_FAILURES_LIST_HEADER: "There are devices on the network that have intermittent faults.",
  DEVICE_WITH_INTERMITTENT_FAILURE: "Device with intermittent fault",

  INTERMITTENT_FAILURES_SUGGESTION_1: "When a device has intermittent faults, it is suggested to:",
  INTERMITTENT_FAILURES_SUGGESTION_2: "Check the IO Device power supply;",
  INTERMITTENT_FAILURES_SUGGESTION_3: "Check the connector's integrity;",
  INTERMITTENT_FAILURES_SUGGESTION_4: "Check the cable's integrity.",

  NO_DEVICE_WITH_INTERMITTENT_FAILURE: "There are no devices on the network with intermittent faults",

  // ---------------------------- LOST IP ----------------------------
  LOST_IP_LIST_HEADER: "There are devices on the network with a possible loss of IP address.",
  LOST_IP_DESCR: "Please check your network.",
  DEVICE_WITH_LOST_IP: "Device with possible loss of IP address",

  LOST_IP_SUGGESTION_1: "When a device presents a possible IP loss, it is suggested to:",
  LOST_IP_SUGGESTION_2: "Check the physical addresses, MAC, to identify the devices that have IP address conflicts, and set appropriate IP addresses to them.",

  // ---------------------------- EXPERT REPORT ----------------------------
  DIAGNOSTIC_PAGE_TITLE: ". - Devices with alarms",
  FAULT_PAGE_TITLE: ". - Devices with faults",
  DUPLICATE_IP_PAGE_TITLE: ". - Devices with Duplicate IP",
  DUPLICATE_NAME_PAGE_TITLE: ". - Devices with duplicate profiname",
  PING_LIMIT_EXCEEDED_PAGE_TITLE: ". - Exceeded ping limit",
  DELTA_ERROR_ALARM_PAGE_TITLE: ". - Error increments",
  PORT_NOT_IN_FULL_DUPLEX_PAGE_TITLE: ". - Port configured in a Duplex mode and/or speed not recommended",
  TRAFFIC_EXCESS_PAGE_TITLE: ". - Traffic exceeded 50 Mbps",
  INACTIVE_PORT_PAGE_TITLE: ". - Inactivated port",
  HW_FW_TITLE: ". - Same hardware versions but different firmware versions",
  MODULE_INCOHERENCE_TITLE: ". - Module different from the one declared in the configuration software",
  DUPLEX_MISMATCH_PAGE_TITLE: ". - Duplex mode incompatibility",
  DELAY_EXCEEDED_PAGE_TITLE: ". - Delay alteration",
  INTERMITTENT_FAILURE_PAGE_TITLE: ". - Devices with intermittent faults",
  LOST_IP_PAGE_TITLE: ". - Device with possible IP loss",

  PORTUGUESE: "Portuguese",
  ENGLISH: "English",
  SPANISH: "Spanish",
  GERMAN: "German",
  UPDATING_LANGUAGE_WAITING: "Changing language, wait a moment",
  UNABLE_TO_ALTER_LANGUAGE: "Unable to change the program's language.\n",

  // ---------------------------- EXPERT REPORT ----------------------------
  DEVICE_WITH_DIAGNOSTIC_DOTS: ".........................................................................................................................",
  DEVICE_WITH_FAULT_DOTS: ".........................................................................................................................",
  DEVICES_WITH_DUPLICATE_IP_DOTS: ".............................................................................................................",
  DEVICES_WITH_DUPLICATE_NAME_DOTS: "................................................................................................",
  PING_LIMIT_EXCEEDED_DOTS: ".......................................................................................................................",
  DELTA_ERROR_ALARM_DOTS: "............................................................................................................................",
  PORT_NOT_IN_FULL_DUPLEX_DOTS: "........................................",
  TRAFFIC_EXCESS_DOTS: "............................................................................................................",
  INACTIVE_PORT_DOTS: ".............................................................................................................................",
  HW_FW_DOTS: ".......................................................",
  HW_FW_DOTS_2: ".........................................................",
  MODULE_INCOHERENCE_DOTS: "...................................",
  MODULE_INCOHERENCE_DOTS_2: ".....................................",
  DUPLEX_MISMATCH_DOTS: "......................................................................................................",
  DUPLEX_MISMATCH_DOTS_2: ".........................................................................................................",

  DELAY_EXCEEDED_DOTS: "............................................................................................................................",
  DELAY_EXCEEDED_DOTS_2: "...............................................................................................................................",

  DEVICE_WITH_INTERMITTENT_FAILURE_DOTS: ".....................................................................................................",
  DEVICE_WITH_INTERMITTENT_FAILURE_DOTS_2: ".......................................................................................................",

  DEVICE_WITH_LOST_IP_DOTS: "........................................................................................",

  DISCLAIMER_EXPERT_DOTS: ".................................................................................................................................",
  DISCLAIMER_EXPERT_DOTS_2: "....................................................................................................................................",

  OVERVIEW_DOTS: "......................................................................................................................................",
  LIVE_LIST_DOTS: ".......................................................................................................................................",
  INVENTORY_DOTS: "......................................................................................................................................",
  TOPOLOGY_DOTS: "......................................................................................................................................",
  IN_TRAFFIC_ERRORS_DOTS: ".............................................................................................................................",
  OUT_TRAFFIC_ERRORS_DOTS: "..........................................................................................................................",
  MON_LOG_DOTS: "................................................................................................................................................",
  DISCLAIMER_DOTS: "..................................................................................................................................",
  DISCLAIMER_DOTS_2: ".....................................................................................................................................",

  ADD_ALTER_TAGS: "Add/Edit Tags",
  CHANGE_TAG_FAILURE: "An error occurred while changing the tag.",
  CHANGE_TAG_SUCCESS: "The tag was changed successfully.",
  CHOOSE_DEVICE: "Choose a device",
  CONFIRM_REMOVE_ALL_TAGS: "Are you sure you want to remove the tags from all devices?",
  EXPORT_TAGS: "Export tags",
  IMPORT_TAGS: "Import tags",
  IMPORT_TAGS_FAILURE: "An error occurred while importing the tags: ",
  IMPORT_TAGS_SUCCESS: "The tags were imported successfully.",
  NEW_TAG: "New tag",
  N_REASON_DP: "\nReason: ",
  PLEASE_SELECT_DEVICE: "Please select a device.",
  PLEASE_SELECT_TAG_FILE: "Please select a tag file.",
  REMOVE: "Remove",
  REMOVE_ALL_TAGS: "Remove all tags",
  REMOVE_TAG_FAILURE: "An error occurred while removing the tags.",
  REMOVE_TAG_SUCCESS: "The tags were removed successfully.",
  TAGS: "Device tags",
  ACTIVE_COLUMNS: "Active columns",

  // PRO topology compatibility
  ACCESS_POINT: "Access Point",
  ADD: "Add",
  ADD_DEVICE: "Add device",
  ALERT_AUTO_DETECTED_CONNECTIONS_CANNOT_BE_REMOVED: "Automatically detected connections cannot be removed.",
  ALERT_CHOOSE_DEVICE_TYPE: "Please select a device type",
  ALERT_MANUAL_CONNECTION_CREATION_FAILED: "Could not create the manual connection.",
  ALERT_ONLY_MANUAL_CONNECTIONS_CAN_BE_REMOVED: "Only manually created connections can be removed.",
  ALERT_ONLY_MANUAL_DEVICES_CAN_BE_EDITED: "Only manually created devices can be edited.",
  ALERT_ONLY_MANUAL_DEVICES_CAN_BE_REMOVED: "Only manually created devices can be removed.",
  ALERT_SELECT_DIFFERENT_DEVICES_FOR_CONNECTION: "Select two different devices to create a connection.",
  CANCEL: "Cancel",
  CHOOSE_A_DEVICE: "Choose a device to view its information",
  CURRENT_JITTER: "Current jitter",
  CURRENT_PING: "Current ping",
  DEVICE_DEFAULT_DROPDOWN_PLACEHOLDER: "Choose a device type",
  ENDPOINT: "Endpoint",
  FIREWALL: "Firewall",
  GRAPHIC_TOPOLOGY_ADD_REGION: "Add region",
  GRAPHIC_TOPOLOGY_CANCEL_REGION_DRAWING: "Cancel drawing",
  GRAPHIC_TOPOLOGY_DEFAULT_REGION_NAME: "Plant",
  GRAPHIC_TOPOLOGY_DEVICES: "Devices",
  GRAPHIC_TOPOLOGY_DEVICES_LOWERCASE: "devices",
  GRAPHIC_TOPOLOGY_DEVICE_TAB: "Device",
  GRAPHIC_TOPOLOGY_DISPLAY_CONFIG_SAVED: "Display settings saved successfully.",
  GRAPHIC_TOPOLOGY_DISPLAY_CONFIG_SAVE_ERROR: "The display settings could not be saved.",
  GRAPHIC_TOPOLOGY_DISPLAY_HELP: "Choose which information is shown below automatic devices.",
  GRAPHIC_TOPOLOGY_DISPLAY_TAB: "Display",
  GRAPHIC_TOPOLOGY_DRAW_REGION_INSTRUCTION: "Click and drag on the topology to draw the region. Release the mouse to enter its name.",
  GRAPHIC_TOPOLOGY_EDIT_REGION: "Edit region",
  GRAPHIC_TOPOLOGY_FILES_HELP: "Export the topology or import a previously saved JSON file.",
  GRAPHIC_TOPOLOGY_FILES_TAB: "Files",
  GRAPHIC_TOPOLOGY_MANUAL_CONNECTION: "Manual connection",
  GRAPHIC_TOPOLOGY_MANUAL_DEVICES: "Added",
  GRAPHIC_TOPOLOGY_NEW_REGION: "New region",
  GRAPHIC_TOPOLOGY_POSITION_HELP: "Edit, save, or remove the current device and region positions.",
  GRAPHIC_TOPOLOGY_POSITION_TAB: "Position",
  GRAPHIC_TOPOLOGY_REGIONS: "Regions",
  GRAPHIC_TOPOLOGY_REGIONS_HELP: "Create plant areas and adjust each region directly on the canvas.",
  GRAPHIC_TOPOLOGY_REGIONS_LOWERCASE: "regions",
  GRAPHIC_TOPOLOGY_REGIONS_TAB: "Regions",
  GRAPHIC_TOPOLOGY_REGION_NAME: "Region name",
  GRAPHIC_TOPOLOGY_REGION_NAME_PLACEHOLDER: "Example: Plant-1",
  GRAPHIC_TOPOLOGY_REGION_NAME_REQUIRED: "Enter the region name.",
  GRAPHIC_TOPOLOGY_REMOVE_REGION: "Remove region",
  GRAPHIC_TOPOLOGY_SEARCH_EMPTY: "Enter an IP, Tag or profiname to search.",
  GRAPHIC_TOPOLOGY_SEARCH_NOT_FOUND_1: "No device found for: ",
  GRAPHIC_TOPOLOGY_SEARCH_NOT_FOUND_2: ".",
  GRAPHIC_TOPOLOGY_SELECTED_REGION_PLACEHOLDER: "Selected region",
  GRAPHIC_TOPOLOGY_SELECT_REGION_TO_EDIT: "Select a region to edit.",
  GRAPHIC_TOPOLOGY_SELECT_REGION_TO_REMOVE: "Select a region to remove.",
  GRAPHIC_TOPOLOGY_SHOW_IP: "Show IP",
  GRAPHIC_TOPOLOGY_SHOW_PROFINAME: "Show profiname",
  GRAPHIC_TOPOLOGY_SHOW_TAG: "Show Tag",
  GRAPHIC_TOPOLOGY_SUBTITLE: "Organize plant devices, connections, and regions",
  GRAPHIC_TOPOLOGY_TITLE: "Graphic topology",
  HAS_TS_EXPERT_EVENT: "Has TS Expert event?",
  HMI: "HMI",
  IP_PLACEHOLDER: "IP (Optional)",
  LOCALE_ADD_DESCRIPTION: "Click on a blank space to add a new device",
  LOCALE_ADD_EDGE: "Add connection",
  LOCALE_ADD_NODE: "Add device",
  LOCALE_BACK: "Back",
  LOCALE_CREATE_EDGE_ERROR: "Unable to create connection to a cluster",
  LOCALE_DEL: "Remover selected",
  LOCALE_DELETE_CLUSTER_ERROR: "Clusters cannot be removed",
  LOCALE_EDGE_DESCRIPTION: "Click on a device and drag the connection to another device to connect them.",
  LOCALE_EDIT: "Edit",
  LOCALE_EDIT_CLUSTER_ERROR: "Clusters cannot be edited",
  LOCALE_EDIT_EDGE: "Edit connection",
  LOCALE_EDIT_EDGE_DESCRIPTION: "Click and drag control points to a device to connect them",
  LOCALE_EDIT_NODE: "Edit device",
  MAX_JITTER: "Maximum jitter",
  MAX_PING: "Maximum ping",
  NO_DEVICE_SELECTED: "No device selected",
  OPEN_DEVICE_IN_GRAPHIC_TOPOLOGY: "Open this device in the Graphic Topology",
  PC: "Notebook",
  PS_2: "PS2:",
  PS_3: "PS3:",
  SELECTED_DEVICE: "Selected device",
  SERVER: "Server",
  SWITCH: "Switch",
  TABLE_TOPOLOGY: "Table Topology",
  TAG_PLACEHOLDER: "TAG",
  TAP: "TAP",
  TOPOLOGY_CSV_EXPORT_NAME: "Topology.xlsx",
  TOPOLOGY_CSV_HEADER: "SNMP,Name,Model,IP,Port,Neighbor name,Neighbor port,Neighbot IP\n",
  UNIQUE_DROPPED: "Unique dropped packets",
  TS_EXPERT_SMART_DIAGNOSIS: "PROFINET smart diagnosis",
  TS_EXPERT_EVENT_TYPES: "Event types",
  TS_EXPERT_OCCURRENCES: "Occurrences",
  TRAFFIC_CSV_HEADER: "IP,Name,Uptime,Port Name,Duplex Mode,Delay,Interface Speed,Inbound Traffic (Kbps),Inbound Packet Errors,Outbound Traffic (Kbps),Outbound Packet Errors,Port Status\n",
  TRAFFIC_CSV_EXPORT_NAME: "Traffic.xlsx",
});

export default Strings;